<template lang="pug">
  .zip-cloud
    b-button.ml-2.mb-2(size="sm", variant="outline-primary", @click="getAddress") 住所検索
</template>

<script>
import Api from "@/repositories/api"
const ZipCloud = Api.get("zipCloud");

export default {
  name: "ZipCloud",
  props: {
    zip_code:   {type: String, required: true}, // 郵便番号
    prefecture: {type: String, required: true}, // 都道府県
    city:       {type: String, required: true}, // 市区町村
    address1:   {type: String, required: true}, // 丁目番地
    error_msg:  {type: String, required: true}, // エラーメッセージ（親画面に表示する用）
  },
  computed: {
    // 都道府県
    local_prefecture: {
      // getter
      get: function() {
        return this.prefecture;
      },
      // setter
      set: function(value) {
        this.$emit("update:prefecture", value);
      }
    },
    // 市区町村
    local_city: {
      // getter
      get: function() {
        return this.city;
      },
      // setter
      set: function(value) {
        this.$emit("update:city", value);
      }
    },
    // 丁目番地
    local_address1: {
      // getter
      get: function() {
        return this.address1;
      },
      // setter
      set: function(value) {
        this.$emit("update:address1", value);
      }
    },
    // エラーメッセージ（親画面に表示する用）
    local_error_msg: {
      // getter
      get: function() {
        return this.error_msg;
      },
      // setter
      set: function(value) {
        this.$emit("update:error_msg", value)
      }
    },
  },
  methods: {
    /**
     * 郵便番号から住所を取得して住所を入力する
     * ※APIから返ってくるエラーメッセージが機械的過ぎるので、エラーメッセージは独自で設定しています。
     *
     * 郵便番号から住所を取得しているAPI
     * 「zip cloud」
     * http://zipcloud.ibsnet.co.jp/doc/api
     */
    getAddress() {
      // 画面に出ているエラーメッセージ削除
      this.local_error_msg = "";

      // 郵便番号がない場合
      if (this.zip_code === undefined || this.zip_code.length <= 0) {
        // エラーメッセージをセット
        this.local_error_msg = "郵便番号を入力してください。";

        // 処理終了
        return;
      }

      // リクエストデータ作成
      const test = {
        zipcode: this.zip_code, // 郵便番号
        limit: 1                // 取得上限
      };

      // リクエスト送信
      ZipCloud.get(test)
      // API呼び出し成功時
      .then((response) => {
        // 住所取得処理失敗
        if (response.data.status === 400) {
          // エラーメッセージをセットする
          this.local_error_msg = "郵便番号に一致する住所が見つかりませんでした。お手数ですが手動で住所を入力してください。";

          // 処理終了
          return void 0;
        }

        // 該当する郵便番号がない場合
        if (Array.isArray(response.data.results) === false || Object.keys(response.data.results).length <= 0) {
          // エラーメッセージをセットする
          this.local_error_msg = "郵便番号に一致する住所が見つかりませんでした。お手数ですが手動で住所を入力してください。";

          // 処理終了
          return void 0;
        }

        // 住所を入力する
        this.local_prefecture = response.data.results[0].address1; // 都道府県
        this.local_city       = response.data.results[0].address2; // 市区町村
        this.local_address1   = response.data.results[0].address3; // 丁目番地
      })
      // 失敗時
      .catch(() => {
        this.local_error_msg = "現在住所検索をすることができません。お手数ですが手動で住所を入力してください。";
      })
    },
  }
}
</script>

<style scoped>

</style>